import { render, staticRenderFns } from "./definitedetail.vue?vue&type=template&id=47570b05&scoped=true"
import script from "./definitedetail.vue?vue&type=script&lang=js"
export * from "./definitedetail.vue?vue&type=script&lang=js"
import style0 from "./definitedetail.vue?vue&type=style&index=0&id=47570b05&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47570b05",
  null
  
)

export default component.exports